import { useQuery } from '@tanstack/react-query';

import { DashboardTemplate } from './dashboards.types';
import { useGetTypeSenseAPIKeys } from '../../REST/typeSenseAPIKeys';
import { TypesenseCollection } from '../types';
import { searchCollection, TypesenseDocument } from '../utils';

const TEMPLATES_FILTER = 'DashboardType:=Template';

export const useGetDashboardTemplates = () => {
  const { data: apiKeys, isError: isKeyError } = useGetTypeSenseAPIKeys();

  const collectionApiKey =
    apiKeys?.[TypesenseCollection.DASHBOARDS.keyName]?.key ?? null;

  const hasDashboardRights = !!collectionApiKey;

  const query = useQuery({
    queryKey: ['DashboardTemplates', collectionApiKey],
    queryFn: async () => {
      const results = await searchCollection(
        TypesenseCollection.DASHBOARDS.name,
        'Name',
        '*',
        collectionApiKey!,
        1,
        250,
        TEMPLATES_FILTER,
      );

      if (!results.success || results.error) {
        throw new Error(
          results.error || 'Failed to fetch dashboard templates from Typesense',
        );
      }

      const mappedResults: DashboardTemplate[] = results?.documents?.map(
        (item: TypesenseDocument) => ({
          id: item.SourceId,
          title: item.Name,
          description: item.Description ?? '',
        }),
      );
      return mappedResults ?? [];
    },
    enabled: hasDashboardRights && !isKeyError,
  });

  return {
    ...query,
  };
};
